<template>
  <el-container class="default" v-loading="loading">
    <el-main style="display: flex; justify-content: space-between; padding: 0; height: 100%;">
      <div class="main" style="height: 1000px;">
        <el-header>
          <div class="title">
            <span class="label">常用功能</span>
            <el-button type="text" class="setting" icon="el-icon-edit" @click="toJump('自定义常用功能', '/yunsierp3/index.html#/security/commonFunctions')">自定义</el-button>
          </div>
          <div class="commonFunctions">
            <div class="commonFunctionsCardGroup" v-if="commonFunctions.length" v-loading="commonFunctionsLoading">
              <div class="commonFunctionsCard" v-for="item in commonFunctions" :key="item.id" @click="toJump(item.title, item.url)">
                <div class="icon">
                  <span class="icon-text">{{ item.title.charAt(0) }}</span>
                </div>
                <span class="desc">{{ item.title }}</span>
              </div>
            </div>
            <div class="commonFunctionsCardGroup" v-else>
              <span style="font-size: 14px; color: #8E8E93;">点击自定义，添加常用功能，使用更顺手！</span>
            </div>
            <!-- 主账号：isMasterAccount -->
            <el-divider direction="vertical" v-if="power.isMasterAccount == 'Y'"></el-divider>
            <div class="commonFunctionsCard" v-if="power.isMasterAccount == 'Y'" @click="toJump('业务流程', '/yunsierp3/index.html#/security/businessflowChart')">
              <div class="icon">
                <img src="@/assets/image/home/businessflow.png" alt="">
              </div>
              <span class="desc">业务流程</span>
            </div>
          </div>
        </el-header>
        <div class="menu">
          <el-tabs v-model="activeName">
            <el-tab-pane label="经营报告" name="G" v-if="power.sysUserTypeID == '001'">
              <management v-if="activeName == 'G'"></management>
            </el-tab-pane>
            <el-tab-pane label="日常工作" name="A">
              <work @toJumps="toJumps" v-if="activeName == 'A'" :menu-list="workList"></work>
            </el-tab-pane>
            <el-tab-pane label="库存管理" name="B">
              <work @toJumps="toJumps" v-if="activeName == 'B'" :menu-list="invList"></work>
            </el-tab-pane>
            <el-tab-pane label="车销流程" name="C">
              <carpin :isBetaVersionAndbetaRunModelOfA="isBetaVersionAndbetaRunModelOfA" @toJumps="toJumps" v-if="activeName == 'C'"></carpin>
            </el-tab-pane>
            <el-tab-pane label="预售流程" name="D" v-if="!isBetaVersionAndbetaRunModelOfA">
              <advance @toJumps="toJumps" v-if="activeName == 'D'"></advance>
            </el-tab-pane>
            <el-tab-pane label="财务管理" name="E">
              <work @toJumps="toJumps" v-if="activeName == 'E'" :menu-list="finList"></work>
            </el-tab-pane>
            <el-tab-pane label="报表管理" name="F">
              <report :isBetaVersionAndbetaRunModelOfA="isBetaVersionAndbetaRunModelOfA" @toJumps="toJumps" v-if="activeName == 'F'"></report>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="aside" style="height: 1000px;">
        <!-- <el-row>
          <el-col :span="24">
            <el-button class="accounts" icon="el-icon-s-finance" @click="toJump('上交款结账', '/Account/sys/salCheckout/indexForVue.html', 70)">快捷结账</el-button>
          </el-col> 
          <el-col :span="24">
            <el-button class="download" icon="el-icon-download" @click="visible = true">软件下载</el-button>
            <el-button class="help" icon="el-icon-help" @click="toJump('常见问题', '/Account/_normalProblem.html')">帮助中心</el-button>
          </el-col>
        </el-row> -->
        <el-row v-if="showCheckout">
          <el-col :span="24">
            <el-button style="background-color: #f15a2b; border-color: #f15a2b; height: 52px; padding: 12px;" v-if="isNewCheckout" @click="toJump('员工交账', '/yunsierp3/index.html#/handPayment/list', 333)">
              <div style="display: flex; align-items: center; justify-content: center;"><i class="iconfont icon-a-5chaokucunxiadan" style="margin-right: 8px; font-size: 20px;"></i>快捷结账</div>
            </el-button>
            <el-button style="background-color: #f15a2b; border-color: #f15a2b; height: 52px; padding: 12px;" v-if="!isNewCheckout" @click="toJump('上交款结账', '/Account/sys/salCheckout/indexForVue.html', 70)">
              <div style="display: flex; align-items: center; justify-content: center;"><i class="iconfont icon-a-5chaokucunxiadan" style="margin-right: 8px; font-size: 20px;"></i>快捷结账</div>
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <div class="live-box">
            <div class="title">
              <div class="line"></div>
              <div class="text">功能推荐</div>
              <div class="line"></div>
            </div>
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(item, index) in liveList" :key="index">
                <div class="image-box">
                  <!-- <img :src="item.picUrl" /> -->
                  <!-- <img src="https://img0.baidu.com/it/u=293428944,389988821&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500" /> -->
                  <el-image :src="item.picUrl" fit="cover" :preview-src-list="liveImageList"></el-image>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-row>
        
        <el-row>
          <el-col :span="10">
            <el-button style="background-color: #1c9d7f; border-color: #1c9d7f; height: 52px; padding: 12px;" @click="visible = true">
              <div style="display: flex; align-items: center; justify-content: center;"><i class="el-icon-download" style="margin-right: 8px; font-size: 20px;"></i>软件下载</div>
            </el-button>
          </el-col>
          <el-col :span="12" :offset="2">
            <el-button style="background: #1d6fdb; border-color: #1d6fdb; height: 52px; padding: 12px;" @click="toJump('云丝商学院', '/templates/vue-account/dist/index.htm#/yunsischool')">
              <div style="display: flex; align-items: center; justify-content: center;"><i class="iconfont icon-a-ziyuan6" style="margin-right: 8px; font-size: 16px;"></i>云丝商学院</div>
            </el-button>
          </el-col>
        </el-row>
        <el-row class="callMe">
          <el-col :span="24">
            <div class="live-box">
              <div class="title">
                <div class="line" style="width: 15px;"></div>
                <div class="text" style="margin: 0 10px;"><i class="iconfont icon-a-kefudianhua1" style="font-size: 16px; margin-right: 4px;"></i>客服电话 400-683-6993</div>
                <div class="line" style="width: 15px;"></div>
              </div>
              <div class="callMe-centent">
                <div>
                  <el-image fit="contain" :src="require('@/assets/image/default/customer_service.jpg')" :preview-src-list="[require('@/assets/image/default/customer_service.jpg')]"></el-image>
                  <span>扫码联系客服</span>
                </div>
                <div>
                  <el-image fit="contain" :src="require('@/assets/image/default/add_customer.jpg')" :preview-src-list="[require('@/assets/image/default/add_customer.jpg')]"></el-image>
                  <span>扫码添加客服</span>
                </div>
                <div>
                  <el-image fit="contain" :src="require('@/assets/image/default/qrcode.jpg')" :preview-src-list="[require('@/assets/image/default/qrcode.jpg')]"> </el-image>
                  <span>新商路服务号</span>
                </div>
                <div>
                  <el-image fit="contain" :src="require('@/assets/image/default/xin_shang_lu_shi_pin_hao.png')" :preview-src-list="[require('@/assets/image/default/xin_shang_lu_shi_pin_hao.png')]"> </el-image>
                  <span>新商路快消宝典</span>
                </div>
                <!-- <div style="justify-content: center;">
                  <div style="display: flex; align-items: center; font-size: 16px;"><i class="iconfont icon-a-kefudianhua1" style="font-size: 24px; margin-right: 4px;"></i>客服电话</div>
                  <span style="font-size: 14px;">400-683-6993</span>
                  <el-divider></el-divider>
                  <div style="display: flex; align-items: center; font-size: 14px;">扫码联系客服<i class="el-icon-right" style="font-size: 14px;"></i></div>
                </div>
                <div>
                  <el-image fit="contain" :src="require('@/assets/image/default/enterpriseWechart.png')" :preview-src-list="[require('@/assets/image/default/enterpriseWechart.png')]"> </el-image>
                </div> -->
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="notice">
          <el-col :span="24" class="live-box" style="margin-top: 0; justify-content: center;">
            <div class="title">
              <div class="line"></div>
              <div class="text">系统公告</div>
              <div class="line"></div>
            </div>
          </el-col>
          <el-col :span="24" class="notice-list">
            <ul>
              <li v-for="item in noticeList" :key="item.id" @click="toJump('系统公告', '/Account/_notice.html')">
                <span>{{ item.title_name }}</span>
                <span>{{ item.enterDate }}</span>
              </li>
            </ul>
          </el-col>
          <div style="font-size: 14px; text-align: center; color: #808080; cursor: pointer;" @click="toJump('系统公告', '/Account/_notice.html')">查看更多<i class="el-icon-d-arrow-right"></i></div>
        </el-row>
      </div>
    </el-main>
    <el-dialog title="软件下载" :visible.sync="visible" custom-class="dialog">
      <el-image fit="fit" style="width: 300px; margin-bottom: 10px" :src="require('@/assets/image/default/appNew.png')"></el-image>
      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-image fit="fit" style="width: 80%;" :src="require('@/assets/image/default/app.jpg')"></el-image>
          <span style="font-size: 18px;">销遥掌柜(推荐使用)</span>
        </el-col>
        <el-col :span="12">
          <el-image fit="fit" style="width: 80%;" :src="require('@/assets/image/default/fwh.jpg')"></el-image>
          <span style="font-size: 18px;">微信公众号</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 12px;">
          <el-col :span="12">
            <el-image fit="fit" style="width: 80%;" :src="require('@/assets/image/default/rxydowncode2.png')"></el-image>
            <span style="font-size: 18px;">业务员端(老版本)</span>
          </el-col>
          <el-col :span="12">
            <el-image fit="fit" style="width: 80%;" :src="require('@/assets/image/default/rxybossdowncode.png')"></el-image>
            <span style="font-size: 18px;">老板端(老版本)</span>
          </el-col>
        </el-row> -->
    </el-dialog>
    
    <!-- AI助手悬浮按钮 -->
    <div v-if="power.isOpenAIHelp == 'Y'" class="ai-assistant-button" @click="openAiDrawer">
      <i class="el-icon-s-promotion"></i>
    </div>
    
    <!-- AI助手抽屉 -->
    <el-drawer
      :visible.sync="aiDrawerVisible"
      direction="rtl"
      size="450px"
      :modal-append-to-body="false"
      :append-to-body="true"
      custom-class="ai-assistant-drawer"
    >
      <iframe :src="VUE_APP_URL + 'erpReport/#/ai?userID=' + userInfo.userID" frameborder="0" class="ai-iframe" style="width: 100%; height: 100%;"></iframe>
    </el-drawer>
  </el-container>
</template>

<script>
import work from "@/components/default/work.vue"
import carpin from "@/components/default/carpin.vue"
import report from "@/components/default/report.vue"
import management from "@/components/default/management.vue"
import advance from "@/components/default/advance.vue"
import { getMenuList as getWorkList } from "@/components/default/work.js"
import { getMenuList as getInvList } from "@/components/default/inv.js"
import { getMenuList as getFinList } from "@/components/default/finance.js"
export default {
  data() {
    let VUE_APP_URL = process.env.VUE_APP_LOCALHOST ? process.env.VUE_APP_LOCALHOST : `${window.location.protocol}//${window.location.host}/`
    return {
      VUE_APP_URL,
      loading: true,
      activeName: "G",
      workList: getWorkList(false),
      invList: getInvList(false),
      finList: getFinList(false),
      noticeList: [],
      liveList: [],
      liveImageList: [],
      visible: false,
      showCheckout: false,
      isNewCheckout: false,
      menuList: [],
      isBetaVersionAndbetaRunModelOfA: false,
      commonFunctions: [],
      commonFunctionsLoading: false,
      power: {},
      userInfo: JSON.parse(sessionStorage.getItem('pcUserInfo') || '{}'),
      aiDrawerVisible: false, // AI助手抽屉显示状态
    }
  },
  components: {
    work,
    carpin,
    report,
    management,
    advance,
  },
  created() {
    if (this.$store.state.power && Object.keys(this.$store.state.power).length) {
      this.toDoByPower(this.$store.state.power)
    } else {
      let unwatch = this.$watch('$store.state.power', (val) => {
        this.toDoByPower(val)
        unwatch()
      })
    }
    this.getPower()
    this.getNoticeList()
    this.getLiveList()
    this.getMenuList()
    this.getComFunList()
    const commonFunctionsUpdate = new BroadcastChannel("commonFunctionsUpdate");
    commonFunctionsUpdate.onmessage = (event) => {
      console.log(event)
      if (event.origin !== window.location.origin) return
      if (event.data.id == 'commonFunctionsUpdate' && event.data.type == 'updated') {
        this.getComFunList()
      }
    }
  },
  methods: {
    toDoByPower(val) {
      this.power = val
      if (val.isBetaVersion == 'Y' && val.betaRunModel == 'A') {
        this.isBetaVersionAndbetaRunModelOfA = true
        this.workList = getWorkList(true)
        this.invList = getInvList(true)
        this.finList = getFinList(true)
      }
      console.log(val);
      if (val.sysUserTypeID != '001') {
        this.activeName = "A"
      }
    },
    async getNoticeList() {
      const { data: res } = await this.$http.post("/Account/noticeDefine/selectNoticeListForVUE.html")
      if (res.result == undefined || res.result == -1) return false
      if (res.code != "success") return this.$message.error(res.message)
      let result = JSON.parse(res.result)
      this.noticeList = JSON.parse(result.data)
    },
    getLiveList() {
      this.$http
        .post(
          "/Account/monitorCenterEnterDefine/selectBroadcast.html",
          this.Qs.stringify({
            page: 1,
            rows: 3,
          })
        )
        .then((res) => {
        //   console.log(res.data.data)
          this.liveList = JSON.parse(res.data.data) || []
          this.liveImageList = this.liveList.map((item) => {
            return item.picUrl
          })
        })
    },
    async getMenuList() {
      const { data: res } = await this.$http.post("/Account/userDefineVue/selectMenuForListByUserIdVue.html")
      this.loading = false
      if (res.result == -1) return false
      if (res.code != "success") return this.$message.error(res.message)
      let result = JSON.parse(res.result)
      this.menuList = result
      let menuItem = this.menuList.filter(item => (item.key == '70' || item.key == '333'))[0] || {}
      this.showCheckout = menuItem?.isCanView == 'Y'
    },
    async getPower() {
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColAndAuthByFuncCode.html', this.Qs.stringify({ funcCode: 201 }))
        res.result = JSON.parse(res.result)
        this.isNewCheckout = JSON.parse(res.result.data).isNewCheckout == 'Y'
    },
    async getComFunList() {
      this.commonFunctionsLoading = true
      const { data: res } = await this.$http.get('/erpnew/account/c/reada46ceb/userConfig/usualFun/byUserId/self')
      this.commonFunctionsLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      this.commonFunctions = res.data.usualFunList
    },
    toJump(text, path, id, idList = [], isView = false) {
      if (id) {
        let objItem = {
          text, url: path
        }
        if(idList && idList.length > 0){
          idList.some(key => {
            objItem = JSON.parse(JSON.stringify(this.menuList.find((i) => i.key && (i.key == key)) || {}))
            return objItem.isCanView == 'Y'
          })
        }else {
          objItem = JSON.parse(JSON.stringify(this.menuList.find((i) => i.key && (i.key == id)) || {}))
        }
        objItem.isView = isView
        if(objItem.isView){
          objItem.text += '查看'
          objItem.url = objItem.viewUrl
        }
        // console.log(objItem)
        if (objItem.isCanView == "Y") {
          top.addPanelwithTab(objItem.text, objItem.url)
        } else {
          this.$message.error("暂无权限")
        }
      } else {
        top.addPanelwithTab(text, path)
      }
    },
    toJumps({ text, path, id, idList, isView }) {
      this.toJump(text, path, id, idList, isView)
    },
    // 打开AI助手抽屉
    openAiDrawer() {
      this.aiDrawerVisible = true
    },
  },
}
</script>
<style scoped src="@/assets/font/pcFont/iconfont.css"></style>
<style lang="less" scoped>
.default {
  height: 100%;
  padding: 20px 0;
  .main {
    min-width: 710px;
    width: 100%;
    margin: 0 0 0 12px;
    display: flex;
    flex-direction: column;
    height: 100%;
    ::v-deep .el-header {
      padding: 20px;
      box-shadow: inset 0px 0px 20px 0px rgba(18, 58, 50, 0.06);
      border-radius: 16px;
      height: auto !important;
      .title {
        font-size: 16px;
        .label {
          color: #333333;
          font-weight: bold;
          margin-right: 24px;
        }
        .setting {
          font-size: 13px;
          color: #2f9b73;
          display: inline-flex;
          // 反转
          flex-direction: row-reverse;
          &:hover,
          &:focus {
            color: #1c7a5c;
          }
        }
      }
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 6px;
        background: #e8f3fd;
        box-shadow: 0px 0px 2px #a4c8ef;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon-text {
          color: #3d7ab5;
          font-size: 25px;
        }
      }
      .commonFunctions {
        display: flex;
        .commonFunctionsCardGroup {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          column-gap: 48px;
          row-gap: 40px;
          padding-bottom: 20px;
          .commonFunctionsCard {
            position: relative;
            .desc {
              position: absolute;
              bottom: 0;
              white-space: nowrap;
              width: 98px;
              // 文本溢出出现省略号
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
              transform: translateY(calc(100% + 4px));
            }
          }
        }
        .commonFunctionsCard {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          // position: relative;
          .desc {
            margin-top: 4px;
            // position: absolute;
          }
        }
        .el-divider {
          height: auto !important;
          margin-right: 24px;
        }
      }
    }
    .menu {
      box-shadow: inset 0px 0px 20px 0px rgba(18, 58, 50, 0.06);
      border-radius: 16px;
      padding: 20px;
      margin-top: 12px;
      flex: 1;
      min-height: 500px;
      // overflow: hidden;
      ::v-deep .el-tabs {
        height: 100%;
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__content {
          height: calc(100% - 40px);
          .el-tab-pane {
            height: 100%;
          }
        }
        .el-tabs__item.is-active {
          color: #123a32;
        }
        .el-tabs__item:hover {
          color: #1c4934;
        }
        .el-tabs__active-bar {
          background-color: #123a32;
        }
      }
    }
  }
  .aside {
    display: flex;
    flex-flow: column;
    padding: 0 20px;
    min-width: 310px;
    max-width: 344px;
    border-radius: 16px;
    // overflow: auto;
    .el-row {
      box-shadow: inset 0px 0px 25px 0px rgba(18, 58, 50, 0.06);
      border-radius: 16px;
      &:not(:nth-child(1)) {
        // margin-top: 20px;
        margin-top: 12px;
      }
      // padding: 20px;
      padding: 2vh;
      .el-col {
        display: flex;
        .el-button {
          flex: 1;
          color: #fff;
        }
        .accounts {
          height: 3.6vw;
          max-height: 100px;
          max-width: 352px;
          background-color: #6590ff;
          border: #6590ff;
          font-size: 1.2vw;
        }
        .download {
          height: 2.4vw;
          max-height: 70px;
          min-height: 36px;
          max-width: 168px;
          font-size: 0.9vw;
          background-color: #ffdd65;
          border: #ffdd65;
        }
        .help {
          height: 2.4vw;
          max-height: 70px;
          min-height: 36px;
          max-width: 168px;
          font-size: 0.9vw;
          background-color: #ff9c65;
          border: #ff9c65;
        }
      }
      &.notice {
        flex: 1;
        min-height: 100px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .notice-title {
          flex: 0 0 auto;
          height: 20px;
        }
        .notice-list {
          flex: 1 1 auto;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .el-col {
          .el-divider {
            width: 0.3vw;
            height: auto;
            background-color: #123a32;
            margin-left: 0;
          }
          &:nth-child(1) {
            color: #123a32;
            font-size: 1vw;
          }
          &:nth-child(2) {
            ul {
              width: 100%;
              li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #666;
                cursor: pointer;
                padding: 6px 0;
                &:hover {
                  color: #2f9b73;
                }
              }
            }
          }
        }
      }
    }
    .live-box {
      flex: 0 0 auto;
      // height: 230px;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 24px;
        .line {
          flex: 0 0 auto;
          width: 32px;
          height: 0px;
          border-bottom: 1px solid #808080;
        }
        .text {
          margin: 0 18px;
          flex: 0 1 auto;
          font-size: 16px;
          color: #808080;
        }
      }
      .el-carousel {
        margin-top: 6px;
        width: 100%;
        height: 168px;
        :deep(.el-carousel__container) {
          height: 168px;
        }
        .image-box {
          width: 100%;
          height: 168px;
          .el-img {
            width: 100%;
            height: 100%;
          }
        }
        :deep(.el-carousel__button) {
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
      }
    }
    .callMe {
      display: flex;
      align-items: center;
      .live-box {
        margin: 0;
      }
      .el-col {
        display: flex;
        flex-flow: column;
        align-items: center;
        font-size: 0.7vw;
        color: #666;
      }
      .callMe-centent {
        margin-top: 6px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        grid-row-gap: 10px;
        // grid-column-gap: 3vw;
        span {
          font-size: 14px;
          margin-top: 2px;
        }
        .el-divider {
          margin: 10px 0;
        }
        & > div {
          display: flex; flex-direction: column; align-items: center;
          width: 104px;
          .el-image {
            // width: 100%;
            height: 90px !important;
            border: 2px solid #CCCCCC;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
::v-deep .dialog {
  .el-dialog__body {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .el-col {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
}

/* AI助手悬浮按钮样式 */
.ai-assistant-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 60px;
  height: 60px;
  background-color: #f15a2b;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 2000;
  transition: all 0.3s;
  
  &:hover {
    transform: scale(1.1);
    background-color: #d9461f;
  }
}

/* AI助手抽屉内iframe样式 */
.ai-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* 自定义抽屉样式 */
:deep(.ai-assistant-drawer) {
  .el-drawer__header {
    margin-bottom: 0;
    color: #333;
    font-weight: bold;
    display: none;
  }
  
  .el-drawer__body {
    padding: 0;
    overflow: hidden;
  }
}
</style>
